module.exports = __webpack_public_path__ + "static/media/back_02.8e9ce95c.png";